const WHATSAPP_NUMBER = '5567991122285'
const DEFAULT_MESSAGE = 'Olhei o site da XP e preciso de ajuda'

export function trackWhatsAppContact(url) {
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'Contact', { content_name: url })
  }
}

export function buildWhatsAppUrl(text = DEFAULT_MESSAGE) {
  const message = typeof text === 'string' ? text : DEFAULT_MESSAGE
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
}

export function openWhatsApp(text = DEFAULT_MESSAGE) {
  const url = buildWhatsAppUrl(text)
  trackWhatsAppContact(url)
  window.open(url, '_blank')
}

export function bindWhatsAppLinkTracking() {
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"]')
    if (!link) return
    trackWhatsAppContact(link.href)
  })
}
